import { TransferRow } from "./transfer-types";

export type TransferStatusFilter = TransferRow["status"] | "all";

export interface TransferFilter {
    query: string;
    status: TransferStatusFilter;
}

export const emptyTransferFilter: TransferFilter = { query: "", status: "all" };

const clientNames = (row: TransferRow): string[] =>
    [
        row.sentClientName,
        row.sentClientBestContactName,
        row.receivedClientName,
        row.receivedClientBestContactName,
    ].filter((name): name is string => !!name);

const matchesQuery = (row: TransferRow, query: string): boolean => {
    const needle = query.trim().toLowerCase();
    if (!needle) {
        return true;
    }
    return clientNames(row).some(name => name.toLowerCase().includes(needle));
};

const matchesStatus = (row: TransferRow, status: TransferStatusFilter): boolean =>
    status === "all" || row.status === status;

export const filterTransferRows = (
    rows: TransferRow[],
    filter: TransferFilter,
): TransferRow[] =>
    rows.filter(
        row => matchesStatus(row, filter.status) && matchesQuery(row, filter.query),
    );
